export const ADD_QUOTE = 'ADD_QUOTE';
export const ADD_CUSTOMER = 'ADD_CUSTOMER';
export const ADD_ORDER = 'ADD_ORDER';

export function addQuote(quote) {
  const actions = {
    type: ADD_QUOTE,
    quote,
  };

  return actions;
}

export function addCustomer(customer) {
  const actions = {
    type: ADD_CUSTOMER,
    customer,
  };

  return actions;
}

export function addOrder(order) {
  const actions = {
    type: ADD_ORDER,
    order,
  };

  return actions;
}
